import { RTL_JOURNEY_PHRASE_TRANSLATIONS } from './rtl.js';
import { WEST_EUROPE_JOURNEY_PHRASE_TRANSLATIONS } from './westEurope.js';
import { EAST_EUROPE_JOURNEY_PHRASE_TRANSLATIONS } from './eastEurope.js';
import { SOUTH_ASIA_JOURNEY_PHRASE_TRANSLATIONS } from './southAsia.js';
import { OTHER_JOURNEY_PHRASE_TRANSLATIONS } from './other.js';
import { DOCTOR_TITLE_PHRASE_TRANSLATIONS } from '../doctorTitlePhraseTranslations.js';
import { JOURNEY_TERMINOLOGY_PHRASE_TRANSLATIONS, JOURNEY_TERMINOLOGY_PHRASE_IDS } from '../journeyTerminologyPhraseTranslations/index.js';

const BASE_JOURNEY_PHRASE_TRANSLATIONS = Object.freeze({
  ...RTL_JOURNEY_PHRASE_TRANSLATIONS,
  ...WEST_EUROPE_JOURNEY_PHRASE_TRANSLATIONS,
  ...EAST_EUROPE_JOURNEY_PHRASE_TRANSLATIONS,
  ...SOUTH_ASIA_JOURNEY_PHRASE_TRANSLATIONS,
  ...OTHER_JOURNEY_PHRASE_TRANSLATIONS,
});

export const JOURNEY_PHRASE_TRANSLATIONS = Object.freeze(Object.fromEntries(
  Object.entries(BASE_JOURNEY_PHRASE_TRANSLATIONS).map(([language, phrases]) => [
    language,
    Object.freeze({ ...phrases, ...(JOURNEY_TERMINOLOGY_PHRASE_TRANSLATIONS[language] || {}) }),
  ]),
));

export const JOURNEY_PHRASE_TRANSLATION_IDS = Object.freeze([
  'breastfeedingSupport',
  'dischargePlanning',
  'criticalCare',
  'intensiveCareUnit',
  'highDependencyUnit',
  'familyVisiting',
  'organSupport',
  'feedingTube',
  'delirium',
  'weaning',
  'criticalCareOutreach',
  'recoveryAfterIcu',
  'oncology',
  'clinicalNurseSpecialist',
  'cancerMdt',
  'biopsy',
  'port',
  'sideEffects',
  'supportiveCare',
  'followUpScan',
  'physiotherapy',
  'occupationalTherapy',
  'oxygenTherapy',
  'nebuliser',
  'cancerDayUnit',
  ...JOURNEY_TERMINOLOGY_PHRASE_IDS,
]);

export function installJourneyPhraseTranslations(i18n, language) {
  if (!i18n?.addResourceBundle) return;
  const normalizedLanguage = String(language || '').toLowerCase().split('-')[0];
  const journeyPhrases = JOURNEY_PHRASE_TRANSLATIONS[normalizedLanguage] || {};
  const doctorTitlePhrases = DOCTOR_TITLE_PHRASE_TRANSLATIONS[normalizedLanguage] || {};
  const phrases = { ...journeyPhrases, ...doctorTitlePhrases };
  if (!Object.keys(phrases).length) return;
  // Merge only after the ordinary whatYouMightHear namespace has loaded. Keep
  // existing reviewed locale strings authoritative if a phrase is later moved
  // into the canonical locale JSON.
  i18n.addResourceBundle(normalizedLanguage, 'whatYouMightHear', { phrases }, true, false);
}
